import { useContext } from 'react'

import CreateApiClientContext from '@dc-shared-web/providers/CreateApiClientContext'

const { Provider, context } = CreateApiClientContext({})

export const SvcCompareVersionsProvider = Provider

export const useSvcCompareVersionsContext = () => useContext(context)
